import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
} from "@mui/material";
import { FieldPath, FieldValues, useController, useFormContext } from "react-hook-form";
import { selectDefaultProps } from "../../../Forms/selectDefaultProps";
import { toKeyValuePairArray } from "../../../Utils/maps";
import { transportTypeAsString, TransportTypes } from "../TransportTypes";
import { emptyMenuItem } from "../../../Forms/SelectDefaultComponents";
import { RhfInputProps } from "../../../Forms/RhfInputProps";
import { RHFFieldErrorText } from "../../../Forms/RHFFieldErrorText";
import { BidPack } from "../BidPack";

export function BidPackTransportTypeSelect<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({ control, name, disabled, ...selectProps }: RhfInputProps<TFieldValues, TName> & SelectProps) {
  const labelId = "transportType-label";
  const label = "Transport Type";

  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  const { trigger } = useFormContext<BidPack>();

  const { setValue } = useFormContext<BidPack>();
  const removeEquipmentTypesWhenTransportTypeIsLTL = (transportType: TransportTypes) => {
    if (transportType === TransportTypes.LTL) {
      setValue("EquipmentIds", []);
      trigger();
    }
  };

  return (
    <FormControl fullWidth size="small" disabled={disabled}>
      <InputLabel id={labelId} shrink>
        {label}
      </InputLabel>
      <Select
        {...selectDefaultProps}
        {...selectProps}
        {...field}
        labelId={labelId}
        label={label}
        disabled={disabled}
        onChange={(event: SelectChangeEvent<unknown>) => {
          field.onChange(event);
          removeEquipmentTypesWhenTransportTypeIsLTL(event.target.value as TransportTypes);
        }}
      >
        {emptyMenuItem(0)}
        {toKeyValuePairArray(transportTypeAsString).map((transportType) => (
          <MenuItem key={transportType.Key} value={transportType.Key}>
            {transportType.Value}
          </MenuItem>
        ))}
      </Select>
      {!!error && <RHFFieldErrorText fieldError={error} />}
    </FormControl>
  );
}
